import {Component, Input} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent {

    @Input() confirmationText: string;

    constructor(private modalRef: NzModalRef) {
    }

    close() {
        this.modalRef.close();
    }

}
